import { ILandingStore, useLandingStore } from "../data/store";

export default function useLandingSize (): DOMRect {
    const landingRect = useLandingStore((state: ILandingStore) => state.landingRect) 
    return landingRect
}